import { Col, Row, Spin } from 'antd'
import Avatar from 'components/Avatar'
import CustomTag from 'components/CustomTag'
import FileReader from 'components/Uploader/FileReader'
import FileReaderVisibleOnly from 'components/Uploader/FileReaderVisibleOnly'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import {
  EditorContent,
  GreyText,
  Marks,
  RewardTite,
  SecondaryHeading,
  StyledP,
  SubFLex,
} from './style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { COLORS } from 'theme'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 16px;
  margin-left: 8px;
`

const EducationSection = ({ studentDetails, instituteName, pendingData, frozenFields }) => {
  const [educationList, setEducationList] = useState([])
  const currentDate = moment()
  const [loading, setLoading] = useState(true)
  console.log('EducationSection pendingData:', pendingData)
  
  const hasFieldPending = (item, fieldName) => {
    return item?._pendingFields && item._pendingFields[fieldName] !== undefined
  }

  const getPendingOrOriginalValue = (item, fieldName) => {
    if (hasFieldPending(item, fieldName)) {
      return item._pendingFields[fieldName].value
    }
    return item[fieldName]
  }
  useEffect(() => {
    setLoading(true)
    
    // Use pendingData if it has the new API structure with _pendingFields
    // The API response structure is: { message: "Success", data: { education: [...], currentCourse: {...} } }
    const hasPendingEducation = pendingData?.data && pendingData.data.education && pendingData.data.education.length > 0
    const dataSource = hasPendingEducation ? pendingData.data : studentDetails
    
    console.log('EducationSection - hasPendingEducation:', hasPendingEducation)
    console.log('EducationSection - dataSource:', dataSource)
    console.log('EducationSection - dataSource.currentCourse:', dataSource?.currentCourse)
    console.log('EducationSection - studentDetails.currentCourse:', studentDetails?.currentCourse)
    
    // The API response has education at root level of data object
    // Get approved education from studentDetails
    const approvedEducation = studentDetails?.educationProfile || studentDetails?.education || []
    
    // Get pending education from pendingData
    const pendingEducation = pendingData?.data?.education || []
    
    // Merge approved and pending education
    const mergedEducation = approvedEducation.map(approvedEdu => {
      const pendingEdu = pendingEducation.find(p => p.id === approvedEdu.id)
      
      if (!pendingEdu) {
        return approvedEdu
      }
      
      const merged = { ...approvedEdu }
      
      // If pending education has _pendingFields, merge those fields
      if (pendingEdu._pendingFields) {
        merged._pendingFields = pendingEdu._pendingFields
        merged._requestId = Object.values(pendingEdu._pendingFields)[0]?._requestId
        
        Object.keys(pendingEdu._pendingFields).forEach(fieldName => {
          const fieldData = pendingEdu._pendingFields[fieldName]
          if (fieldData.value !== null && fieldData.value !== undefined) {
            merged[fieldName] = fieldData.value
          }
        })
      }
      
      return merged
    })
    
    // Add new education items (those with _isNew flag or temp_id)
    const newPendingEducation = pendingEducation.filter(e => e._isNew || e.temp_id)
    
    const educationData = [...mergedEducation, ...newPendingEducation]
    
    // Process currentCourse with pending data
    // Merge pendingData (has _pendingFields) with studentDetails (has full currentCourse details)
    const pendingCurrentCourse = pendingData?.data?.currentCourse || {}
    const originalCurrentCourse = studentDetails?.currentCourse || {}
    
    // Find matching education item to get full details if currentCourse is incomplete
    const educationItem = educationData.find(edu => 
      (edu.educationLevel === 'ug' || edu.educationLevel === 'pg') && 
      edu._isNew !== true
    )
    
    // Use originalCurrentCourse as base (has all the data), apply pending fields from pendingCurrentCourse
    let currentCourse = {
      id: originalCurrentCourse?.id || pendingCurrentCourse?.id,
      isCurrentCourse: true,
      educationLevel: originalCurrentCourse?.educationLevel || educationItem?.educationLevel,
      institutionName: studentDetails?.instituteCampusName || educationItem?.institutionName,
      board: '',
      degree: originalCurrentCourse?.degree || educationItem?.degree,
      department: originalCurrentCourse?.department || educationItem?.department,
      specialisation: originalCurrentCourse?.specialisation || educationItem?.specialisation,
      degreeStreamMapId: originalCurrentCourse?.degreeStreamMapId || educationItem?.degreeStreamMapId,
      startedOn: originalCurrentCourse?.startedOn || educationItem?.startedOn,
      endedOn: originalCurrentCourse?.endedOn || educationItem?.endedOn,
      marks: originalCurrentCourse?.marks || educationItem?.marks,
      averageMarks: originalCurrentCourse?.averageMarks || educationItem?.averageMarks,
      skills: originalCurrentCourse?.skills || educationItem?.skills,
      state: originalCurrentCourse?.state || educationItem?.state || '',
      city: originalCurrentCourse?.city || educationItem?.city || '',
      country: originalCurrentCourse?.country || educationItem?.country || '',
      markSheetUrl: originalCurrentCourse?.markSheetUrl || educationItem?.markSheetUrl,
      // Merge _pendingFields from both sources
      _pendingFields: {
        ...educationItem?._pendingFields,
        ...originalCurrentCourse?._pendingFields,
        ...pendingCurrentCourse?._pendingFields
      },
      _requestId: pendingCurrentCourse?._requestId || originalCurrentCourse?._requestId || educationItem?._requestId,
      _status: pendingCurrentCourse?._status || originalCurrentCourse?._status || educationItem?._status
    }
    
    const allEducation = [...educationData]
    
    let schoolLevel = []
    let collegeLevel = []
    allEducation?.map((item, index) => {
      if (
        item?.educationLevel === 'twelfth' ||
        item?.educationLevel === 'tenth'
      ) {
        schoolLevel.push(item)
      } else {
        collegeLevel.push(item)
      }
    })
    if (studentDetails?.student?.isExpCandidate) {
      setLoading(true)
      let educationList = [...collegeLevel, ...schoolLevel]

      educationList?.sort((a, b) => {
        // Handle both endedOn (for college) and endYear (for school)
        const endedA = moment(parseInt(a?.endedOn || a?.endYear))
        const endedB = moment(parseInt(b?.endedOn || b?.endYear))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)
      setLoading(false)
    } else if (!studentDetails?.student?.isExpCandidate) {
      setLoading(true)

      let educationList = [currentCourse]
      
      if (collegeLevel.length > 0 || schoolLevel.length > 0) {
        educationList = [currentCourse, ...collegeLevel, ...schoolLevel]
      }

      educationList?.sort((a, b) => {
        // Handle both endedOn (for college) and endYear (for school)
        const endedA = moment(parseInt(a?.endedOn || a?.endYear))
        const endedB = moment(parseInt(b?.endedOn || b?.endYear))

        // Check if both dates are valid
        if (!endedA.isValid() || !endedB.isValid()) {
          return 0
        }

        // Sort by the "ended_in" date in descending order
        if (endedB.isAfter(endedA)) return 1
        if (endedA.isAfter(endedB)) return -1
      })
      setEducationList(educationList)

      setLoading(false)
    }
  }, [studentDetails, instituteName, pendingData])
  useEffect(() => {
    let count = 0
    for (let i = 0; i < studentDetails?.currentCourse?.marks?.length; i++) {
      if (studentDetails?.currentCourse?.marks[i].mark === 0) {
        count++
      }
    }
  }, [studentDetails])
  const getEduLevel = value => {
    if (
      value.educationLevel === 'ug' ||
      value.educationLevel === 'pg' ||
      value.educationLevel === 'phd' ||
      value.educationLevel === 'diploma' ||
      value.educationLevel === 'p_g_diploma' ||
      value.educationLevel === 'otherEducation'
    ) {
      const degree = getPendingOrOriginalValue(value, 'degree')
      const department = getPendingOrOriginalValue(value, 'department')
      return degree?.toLowerCase() + ' in ' + department
    } else {
      return getPendingOrOriginalValue(value, 'board')
    }
  }
  const getEducationDate = value => {
    const startedOn = getPendingOrOriginalValue(value, 'startedOn')
    // Prioritize endYear if it exists (for pending data), otherwise use endedOn
    const endYear = getPendingOrOriginalValue(value, 'endYear')
    const endedOn = getPendingOrOriginalValue(value, 'endedOn')
    
    // Use endYear if it has a value, otherwise fall back to endedOn
    const finalEndYear = (endYear && endYear > 0) ? endYear : endedOn
    
    if (
      value.educationLevel === 'ug' ||
      value.educationLevel === 'pg' ||
      value.educationLevel === 'phd' ||
      value.educationLevel === 'diploma' ||
      value.educationLevel === 'p_g_diploma' ||
      value.educationLevel === 'otherEducation'
    ) {
      if(!value?.isCurrentCourse){
        return (
        <span>
          {startedOn > 0 ? (
            <>
              {moment(parseInt(startedOn)).format('YYYY')} -{' '}
            </>
          ) : null}
          {finalEndYear > 0 ? moment(parseInt(finalEndYear)).format('YYYY') : ''}
        </span>
      )
    }
    else{
      return (
        <span>
          {startedOn > 0 ? (
            <>
              {moment(parseInt(startedOn)).format('MMM YYYY')} -{' '}
            </>
          ) : null}
          {finalEndYear > 0 ? moment(parseInt(finalEndYear)).format('MMM YYYY') : ''}
        </span>
      )
    }
    } else if (finalEndYear > 0) {
      return <span>{moment(parseInt(finalEndYear)).format('YYYY')}</span>
    }
  }

  const roundOff = mark => {
    return Number(mark).toFixed(2)
  }

  const getEducationLevelLabel = level => {
    switch (level) {
      case 'tenth':
        return '10th'
      case 'twelfth':
        return '12th'
      case 'puc':
        return 'Diploma'
      case 'p_g_diploma':
        return 'PG DIPLOMA'
      case 'diploma':
        return 'Diploma'
      case 'ug':
        return 'UG'
      case 'pg':
        return 'PG '
      case 'phd':
        return 'PD'
      case 'pd':
        return 'PD'
      case 'otherEducation':
        return 'Other'
      default:
        break
    }
  }

  return (
    <>
      {!loading && (
        <SubFLex column gap="25px" style={{ width: '100%' }}>
          {!loading &&
            educationList?.length > 0 &&
            educationList?.map((item, index) => (
              <Row style={{ width: '100%' }} key={index + 'education'}>
                <Col span={20}>
                  <SubFLex gap="12px">
                    <div>
                      <Avatar
                        background="none"
                        size={48}
                        icon={<ApartmentIcon />}
                        boxShadow={true}
                        padding="5px"
                      />
                    </div>
                    <SubFLex column style={{ width: '90%' }}>
                      <SubFLex gap="20px" flexStart>
                        <SecondaryHeading fontWeight="600" style={{ display: 'flex', alignItems: 'center' }}>
                          <span>
                            {getEducationLevelLabel(item?.educationLevel)}
                            {getEducationLevelLabel(item?.educationLevel) &&
                              getPendingOrOriginalValue(item, 'institutionName') &&
                              ' - '}
                            {getPendingOrOriginalValue(item, 'institutionName')}
                            {/* {hasFieldPending(item, 'institutionName') && <PendingIcon />} */}
                          </span>
                        </SecondaryHeading>

                        {(item?._requestId || item?._status === 'PENDING' || item?._isNew || (item?._pendingFields && Object.keys(item._pendingFields).length > 0)) && (
                          <CustomTag
                            message={item?.id ? "Need Approval" : "Need Approval"}
                            bordered={true}
                            background={'#eb5d60'}
                            border={'#eb5d60'}
                            color={'#fff'}
                          />
                        )}

                        {item?.isCurrentCourse ? (
                          <CustomTag
                            message="Currently Pursuing"
                            bordered={true}
                            background="none"
                            colorType="grey"
                            border={COLORS.GREY_T_80}
                          />
                        ) : (
                          <></>
                        )}
                      </SubFLex>
                      <GreyText color={COLORS.GREY_T_60} style={{ display: 'flex', alignItems: 'center' }}>
                        <span>
                          {getEducationDate(item)} {getPendingOrOriginalValue(item, 'city')}
                          {getPendingOrOriginalValue(item, 'city') && ','}
                          {getPendingOrOriginalValue(item, 'state')}
                        </span>
                        {/* {(hasFieldPending(item, 'startedOn') || hasFieldPending(item, 'endedOn') || hasFieldPending(item, 'city') || hasFieldPending(item, 'state')) && <PendingIcon />} */}
                      </GreyText>
                      <GreyText style={{ display: 'flex', alignItems: 'center' }}>
                        <span>
                          {getEduLevel(item)}{' '}
                          {getPendingOrOriginalValue(item, 'specialisation')
                            ? `(${getPendingOrOriginalValue(item, 'specialisation')})`
                            : null}
                        </span>
                        {/* {(hasFieldPending(item, 'degree') || hasFieldPending(item, 'department') || hasFieldPending(item, 'board') || hasFieldPending(item, 'specialisation')) && <PendingIcon />} */}
                      </GreyText>
                      {item?.skills?.length > 0 && (
                        <SecondaryHeading fontWeight="600">
                          Skills
                        </SecondaryHeading>
                      )}
                      <SubFLex
                        centerVertically
                        gap="5px"
                        marginBottom="15px"
                        wrap
                      >
                        {item?.skills?.map((value, key) => (
                          <CustomTag
                            message={value?.name}
                            key={key + 'skills'}
                            bordered={true}
                            background={'#F2F3F5'}
                            border={'#F2F3F5'}
                          />
                        ))}
                      </SubFLex>
                      {
                        getPendingOrOriginalValue(item, 'markSheetUrl') &&
                        Object.keys(getPendingOrOriginalValue(item, 'markSheetUrl')).length > 0 && (
                          <>
                            {hasFieldPending(item, 'markSheetUrl') || item._isNew ? (
                              <div
                                style={{
                                  background: '#FFE5E6',
                                  padding: '12px 16px',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  marginTop: '8px',
                                  marginBottom: '8px'
                                }}
                              >
                                <span style={{ fontSize: '14px', color: '#1F2937' }}>
                                  Marksheet Submitted - <span style={{ color: '#3249D7', fontWeight: 500 }}>{getPendingOrOriginalValue(item, 'markSheetUrl')?.name || 'Document.jpg'}</span>
                                </span>
                                <button
                                  onClick={() => {
                                    const newWindow = window.open(getPendingOrOriginalValue(item, 'markSheetUrl')?.url, '_blank', 'noopener,noreferrer')
                                    if (newWindow) newWindow.opener = null
                                  }}
                                  style={{
                                    background: '#3249D7',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '6px',
                                    padding: '6px 20px',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    cursor: 'pointer'
                                  }}
                                >
                                  View
                                </button>
                              </div>
                            ) : (
                              <FileReaderVisibleOnly 
                                file={getPendingOrOriginalValue(item, 'markSheetUrl')} 
                                disabled={frozenFields?.markSheetUrl || false}
                              />
                            )}
                          </>
                        )}
                      <br></br>
                      {item?.awards?.length > 0 &&
                        studentDetails?.student?.isExpCandidate && (
                          <RewardTite>Rewards and Recognition </RewardTite>
                        )}
                      {item?.awards?.map((value, key) => (
                        <SubFLex
                          column
                          gap="25px"
                          marginBottom="10px"
                          key={key + 'awards'}
                        >
                          <SubFLex gap="12px">
                            <div>
                              <Avatar
                                background="none"
                                size={48}
                                icon={<AwardsIconWork />}
                                boxShadow={true}
                                padding="5px"
                              />
                            </div>
                            <SubFLex column style={{ width: '90%' }}>
                              <SecondaryHeading>
                                {value?.title}
                              </SecondaryHeading>

                              <GreyText color={COLORS.GREY_T_60}>
                                {moment(value?.awarded_on).format(
                                  'DD MMM YYYY'
                                )}
                              </GreyText>

                              <StyledP>
                                {' '}
                                <EditorContent
                                  dangerouslySetInnerHTML={{
                                    __html: value?.description || '',
                                  }}
                                />{' '}
                              </StyledP>
                              {value?.certificate && (
                                <FileReaderVisibleOnly
                                  file={value?.certificate}
                                />
                              )}
                            </SubFLex>
                          </SubFLex>
                        </SubFLex>
                      ))}
                    </SubFLex>
                  </SubFLex>
                </Col>
                <Col span={4}>
                  <div style={{ width: 'max-content' }}>
                      <Marks style={{ display: 'flex', alignItems: 'center' }}>
                        <span>
                          {!item?.isCurrentCourse &&
                            'Marks - ' + roundOff(getPendingOrOriginalValue(item, 'marks')) + '%'}

                        {item?.isCurrentCourse && Number(getPendingOrOriginalValue(item, 'averageMarks')) >= 1
                          ? 'Marks  - ' + `${roundOff(getPendingOrOriginalValue(item, 'averageMarks'))}` + '% '
                          : null}
                        </span>
                        {/* {(hasFieldPending(item, 'marks') || hasFieldPending(item, 'averageMarks')) && <PendingIcon />} */}
                      </Marks>
                    </div>
                  </Col>
                </Row>
              ))}
        </SubFLex>
      )}
      {loading && <Spin />}
    </>
  )
}

export default EducationSection
